var React = require('react');

function Twitch (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M45,1H5C2.8,1,1,2.8,1,5v40c0,2.2,1.8,4,4,4h40c2.2,0,4-1.8,4-4V5C49,2.8,47.2,1,45,1z","fill":"#6441A5","key":0}),React.createElement("g",{"id":"_x7C___x7C_","key":1},[React.createElement("path",{"d":"M31,36h-6l-3,4h-4v-4h-7V15.1l2-5.1h26v18L31,36z M36,27V13H15v19h6v4l4-4h6L36,27z","fill":"#FFFFFF","id":"Dialog","key":0}),React.createElement("rect",{"fill":"#FFFFFF","height":"8","id":"_x7C_","width":"3","x":"28","y":"18","key":1}),React.createElement("rect",{"fill":"#FFFFFF","height":"8","id":"_x7C__2_","width":"3","x":"22","y":"18","key":2})])]);
}

Twitch.defaultProps = {"enableBackground":"new 0 0 50 50","id":"Layer_1","version":"1.1","viewBox":"0 0 50 50","xmlSpace":"preserve"};

module.exports = Twitch;

Twitch.default = Twitch;
